export const adjustCinemaArrowHeight = (cinema) => {
    const cinemaTileHeight = cinema.querySelector(".reco_cinema__image")?.getBoundingClientRect().height * 0.52;
    if (cinemaTileHeight > 0) cinema.setAttribute("arrow-button-position", cinemaTileHeight + "px");
};

export const setEECSvgImagePrefix = (svgImageUrlPrefix, eecComponentId, multipleEccCount) => {
    for (let i = 0; i < multipleEccCount; i++) {
        const energyLabel = document?.getElementById(i + "-" + eecComponentId);
        const elementWithEnergyIcon = energyLabel?.shadowRoot?.querySelector("div > svg > use");
        elementWithEnergyIcon?.setAttribute("href", svgImageUrlPrefix + elementWithEnergyIcon.getAttribute("href"));
    }
};
